import { Text } from '@visx/text';

import { CHART_HOVER_OPACITY, CHART_HOVER_TRANSITION } from '../../constants';
import { BarChartData } from '../../types';

export const XAxisLabel = ({
  handleLegendItemMouseOut,
  handleLegendItemMouseOver,
  hoveredLegendItem,
  resource,
  theme,
  x,
  y,
}: {
  handleLegendItemMouseOut: () => void;
  handleLegendItemMouseOver: (datum: BarChartData[number]) => void;
  hoveredLegendItem: BarChartData[number] | null;
  resource: BarChartData[number];
  theme: any;
  x: number;
  y: number;
}) => {
  const isItemHovered = hoveredLegendItem?.name === resource.name;
  const itemOpacity = hoveredLegendItem ? (isItemHovered ? 1 : CHART_HOVER_OPACITY) : 1;

  return (
    <Text
      dy={4}
      fill={theme.palette.text.secondary}
      fontFamily={theme.typography.caption.fontFamily}
      fontSize={theme.typography.caption.fontSize}
      fontWeight={theme.typography.caption.fontWeight}
      onMouseMove={() => handleLegendItemMouseOver(resource)}
      onMouseOut={handleLegendItemMouseOut}
      opacity={itemOpacity}
      style={{ cursor: 'pointer', transition: CHART_HOVER_TRANSITION }}
      textAnchor="middle"
      width={130}
      x={x}
      y={y}
    >
      {resource.name}
    </Text>
  );
};
